import React from 'react';
import './Services.css';

const Services = () => {
  // Dynamic data matching the image content
  const servicesData = [
    {
      id: 1,
      title: "Residential Roofing",
      description: "Complete roof replacement, repair, and installation for your home.",
      iconClass: "bi bi-house-door", // Matches the house icon
      type: "standard"
    },
    {
      id: 2,
      title: "Commercial Roofing",
      description: "Durable and efficient roofing solutions for businesses and industrial properties.",
      iconClass: "bi bi-building", // Matches the office building icon
      type: "standard"
    },
    {
      id: 3,
      title: "Storm Damage Repair",
      description: "Rapid response and repair for roofs damaged by wind, hail, or storms.",
      iconClass: "bi bi-cloud-lightning-rain", // Matches the storm icon
      type: "standard"
    },
    {
      id: 4,
      title: "Schedule your roofing consultation",
      description: "",
      iconClass: "bi bi-chat-dots", // Matches the consultation icon
      type: "cta" // The blue highlight card
    }
  ];

  return (
    <section className="services-section">
      <div className="container">
        <div className="services-header text-center mb-5">
          <p className="subtitle">Our Services</p>
          <h2 className="main-title text-white">Complete Roofing Solutions</h2>
          <p className="header-desc">From residential repairs to commercial installations, we deliver exceptional roofing services that protect what matters most to you.</p>
        </div>

        <div className="services-grid">
          {servicesData.map((service) => (
            <div 
              key={service.id} 
              className={`service-card ${service.type === 'cta' ? 'card-blue' : 'card-dark'}`}
            >
              <div className="service-icon-box">
                <i className={service.iconClass}></i>
              </div>
              <h3 className="service-title">{service.title}</h3>
              {service.description && (
                <p className="service-text">{service.description}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;